import { getMealPlanRating, getMealPlanRatingCount } from 'common/RatingUtilities';
import { Icon, IconColor } from 'web-common/src/shared/design-system/components/Icon';

interface IProps {
  ratingCount: number;
  averageRating: number;
  foodItemId: number;
}

export const FoodItemRatings: React.FC<IProps> = ({ ratingCount, averageRating, foodItemId }) => (
  <div className='flex items-center'>
    <Icon name='thumbsUp' size={16} color={IconColor.EGGPLANT_400} />
    <p className='ml-1 text-caption-600 font-bold text-eggplant'>
      {getMealPlanRating(ratingCount, averageRating, foodItemId)}%
    </p>
    <p className='ml-1 text-label-400 text-eggplant-300'>({getMealPlanRatingCount(ratingCount, foodItemId)})</p>
  </div>
);
